"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDefaultEmptyComponent = createDefaultEmptyComponent;
function createDefaultEmptyComponent(_ref) {
  var createElement = _ref.createElement,
    Fragment = _ref.Fragment;
  return function DefaultEmpty() {
    return createElement(Fragment, null, "No results");
  };
}